module.exports = __webpack_public_path__ + "media/application/images/icons/2-green-86b2131323387da1f1a762549d29eba3.svg";